import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

export default function initScrollLockBlock() {
	
    const init = () => {
        document.querySelectorAll('.scroll-lock-block').forEach((block) => {
            const scrollLockContainer = block.querySelector('.scroll-lock-container');
            const scrollLockContent = scrollLockContainer.querySelector('.scroll-lock');
            const offsetY = document.querySelector('.nav-anchorlinks-section') ? '190px' : '160px';
            const scrollBlockH = block.querySelector('.scroll-lock').offsetHeight; 
console.log( scrollBlockH );
            gsap.registerPlugin(ScrollTrigger);
            
            let matchMedia = gsap.matchMedia();
            matchMedia.add('screen and (min-width: 1200px)' , () => {
                ScrollTrigger.create({
                    trigger: scrollLockContainer,
                    start: 'top-=' + offsetY + 'px',
                    end: 'bottom top+=' + scrollBlockH + 'px',
                    pin: scrollLockContent,
                    pinSpacing: false,
                // pinnedContainer: scrollLockContainer,
                    invalidateOnRefresh: false,
                    markers: false,
                    // 

                });
            });

        });
    }

    init();


}
